var _style, _path, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{clip-path:url(#SVGID_2_);}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#32A6DC;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "categoria"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Background",
    className: "st0",
    d: "M0,0h50v50H0V0z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 50,
    height: 50
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st2",
    d: "M46.1,1.6H3.9c-1.3,0-2.3,1-2.3,2.3v42.2c0,1.3,1,2.3,2.3,2.3h42.2c1.3,0,2.3-1,2.3-2.3V3.9 C48.4,2.6,47.4,1.6,46.1,1.6L46.1,1.6z M46.9,46.1c0,0.4-0.3,0.8-0.8,0.8H3.9c-0.4,0-0.8-0.3-0.8-0.8V3.9c0-0.4,0.3-0.8,0.8-0.8 h42.2c0.4,0,0.8,0.3,0.8,0.8V46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Circle",
    className: "st2",
    d: "M4.7,5.5C4.7,5,5,4.7,5.5,4.7S6.2,5,6.2,5.5S5.9,6.2,5.5,6.2S4.7,5.9,4.7,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Circle_1_",
    className: "st2",
    d: "M7,5.5C7,5,7.4,4.7,7.8,4.7S8.6,5,8.6,5.5S8.2,6.2,7.8,6.2S7,5.9,7,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Circle_2_",
    className: "st2",
    d: "M9.4,5.5c0-0.4,0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8s-0.3,0.8-0.8,0.8 C9.7,6.2,9.4,5.9,9.4,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    className: "st2",
    d: "M24.2,21.1h-3.1c-0.2,0-0.4,0.1-0.6,0.2c-0.1,0.1-0.2,0.3-0.2,0.6V25c0,0.2,0.1,0.4,0.2,0.6 c0.1,0.1,0.3,0.2,0.6,0.2h3.1c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.2-0.6v-3.1c0-0.2-0.1-0.4-0.2-0.6 C24.6,21.2,24.4,21.1,24.2,21.1L24.2,21.1z M23.4,24.2h-1.6v-1.6h1.6V24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_",
    className: "st2",
    d: "M27.3,22.7h2.3v1.6h-2.3V22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_",
    className: "st2",
    d: "M31.2,22.7h10.9v1.6H31.2V22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4_",
    className: "st2",
    d: "M24.2,27.3h-3.1c-0.2,0-0.4,0.1-0.6,0.2c-0.1,0.1-0.2,0.3-0.2,0.6v3.1c0,0.2,0.1,0.4,0.2,0.6 c0.1,0.1,0.3,0.2,0.6,0.2h3.1c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.2-0.6v-3.1c0-0.2-0.1-0.4-0.2-0.6 C24.6,27.4,24.4,27.3,24.2,27.3L24.2,27.3z M23.4,30.5h-1.6v-1.6h1.6V30.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5_",
    className: "st2",
    d: "M27.3,28.9h2.3v1.6h-2.3V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6_",
    className: "st2",
    d: "M31.2,28.9h10.9v1.6H31.2V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7_",
    className: "st2",
    d: "M24.2,33.6h-3.1c-0.2,0-0.4,0.1-0.6,0.2s-0.2,0.3-0.2,0.6v3.1c0,0.2,0.1,0.4,0.2,0.6 c0.1,0.1,0.3,0.2,0.6,0.2h3.1c0.2,0,0.4-0.1,0.6-0.2s0.2-0.3,0.2-0.6v-3.1c0-0.2-0.1-0.4-0.2-0.6C24.6,33.7,24.4,33.6,24.2,33.6 L24.2,33.6z M23.4,36.7h-1.6v-1.6h1.6V36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_8_",
    className: "st2",
    d: "M27.3,35.2h2.3v1.6h-2.3V35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_9_",
    className: "st2",
    d: "M31.2,35.2h10.9v1.6H31.2V35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_10_",
    className: "st2",
    d: "M24.2,39.8h-3.1c-0.2,0-0.4,0.1-0.6,0.2s-0.2,0.3-0.2,0.6v3.1c0,0.2,0.1,0.4,0.2,0.6 c0.1,0.1,0.3,0.2,0.6,0.2h3.1c0.2,0,0.4-0.1,0.6-0.2S25,44,25,43.8v-3.1c0-0.2-0.1-0.4-0.2-0.6C24.6,39.9,24.4,39.8,24.2,39.8 L24.2,39.8z M23.4,43h-1.6v-1.6h1.6V43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_11_",
    className: "st2",
    d: "M27.3,41.4h2.3V43h-2.3V41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_12_",
    className: "st2",
    d: "M31.2,41.4h10.9V43H31.2V41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_13_",
    className: "st2",
    d: "M43.8,9.4H6.2C6,9.4,5.8,9.5,5.7,9.6c-0.1,0.1-0.2,0.3-0.2,0.6v33.6c0,0.2,0.1,0.4,0.2,0.6 c0.1,0.1,0.3,0.2,0.6,0.2h10.9c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.2-0.6v-25h25.8c0.2,0,0.4-0.1,0.6-0.2s0.2-0.3,0.2-0.6 v-7.8c0-0.2-0.1-0.4-0.2-0.6S44,9.4,43.8,9.4L43.8,9.4z M16.4,43H7V18.8h9.4V43z M43,17.2H7v-6.2H43V17.2z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.a897f6519d5d63168eaa06c7a8eba106.svg";
export { ForwardRef as ReactComponent };